"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const crypto_1 = require("crypto");
const secp256k1_1 = require("secp256k1");
function verifyPublicKey(publicKey) {
    return (publicKey &&
        Buffer.isBuffer(publicKey) &&
        secp256k1_1.publicKeyVerify(publicKey));
}
exports.verifyPublicKey = verifyPublicKey;
function verifyPrivateKey(privateKey) {
    return (privateKey &&
        Buffer.isBuffer(privateKey) &&
        secp256k1_1.privateKeyVerify(privateKey));
}
exports.verifyPrivateKey = verifyPrivateKey;
function privateToPublicKey(privateKey) {
    let result = null;
    if (verifyPrivateKey(privateKey)) {
        result = secp256k1_1.publicKeyCreate(privateKey, false);
    }
    return result;
}
exports.privateToPublicKey = privateToPublicKey;
function generateRandomPrivateKey() {
    let result;
    for (;;) {
        result = crypto_1.randomBytes(32);
        if (verifyPrivateKey(result)) {
            break;
        }
    }
    return result;
}
exports.generateRandomPrivateKey = generateRandomPrivateKey;
//# sourceMappingURL=utils.js.map